import {
    createSelector, createSlice,
} from "@reduxjs/toolkit";
import { RequestStatus } from "../../Model/Enums";
import { IAppState } from "../../Store/store";
import { getPendingApprovals1Thunk, getApprovalDetails1Thunk, postDeleteApprovals1Thunk, deleteApprovals1Thunk, systemSlice1Reducer, ISystemSlice1State } from "../../Store/SystemTemplate/SystemSlice1";

export const eJourneySliceInitialState: ISystemSlice1State = {
    pendingApprovalsStatus: RequestStatus.Idle,
    pendingApprovalsError: null,
    selectedApprovalDetailStatus: RequestStatus.Idle,
    selectedApprovalDetailError: null,
    supportMulti: false,
    selectedApproval: null,
    selectedApprovalDetails: null,
    multiSelectedApprovals: [],
    searchQuery: "",
    isAsc: false,
    selectedSubSystem: null,
    fromPosition: 0,
    subSystems: [],
    totalCountForFilter: 0,
    pendingApprovals: [],
    isTabletView: false,

};


const EJourneySlice = createSlice({
    name: "Trip",
    initialState: eJourneySliceInitialState,
    reducers: systemSlice1Reducer
});

export const GetPendingApprovals = getPendingApprovals1Thunk(eJourneySliceInitialState, EJourneySlice, "Trip", "Trip");

export const GetApprovalDetails = getApprovalDetails1Thunk(EJourneySlice, "Trip", "Trip");

export const PostDeleteApprovals = postDeleteApprovals1Thunk(EJourneySlice, "Trip");

export const DeleteApprovals = deleteApprovals1Thunk(EJourneySlice, "Trip", "Trip");

//Action
export const {
    resetSystemSliceState,
    setPendingApprovalsStatus,
    setSelectedApproval,
    setSelectedApprovalDetails,
    setMultiSelectedApprovals,
    setSearchQuery,
    setIsAsc,
    setSelectedSubSystem,
    setFromPosition,
    setSubSystems,
    setTotalCountForFilter,
    setPendingApprovals,
    addToPendingApprovals,
    reCalculateSelectedApproval,
    setIsTabletView,
} = EJourneySlice.actions;

//Selector
export const EJourneySelector = (state: IAppState) => state.Trip;
export const PendingApprovalsStatusSelector = createSelector(
    EJourneySelector,
    (details) => details?.pendingApprovalsStatus
);
export const PendingApprovalsErrorSelector = createSelector(
    EJourneySelector,
    (details) => details?.pendingApprovalsError
);
export const SelectedApprovalDetailStatusSelector = createSelector(
    EJourneySelector,
    (details) => details?.selectedApprovalDetailStatus
);
export const SelectedApprovalDetailErrorSelector = createSelector(
    EJourneySelector,
    (details) => details?.selectedApprovalDetailError
);
export const SupportMultiSelector = createSelector(
    EJourneySelector,
    (details) => details?.supportMulti
);
export const SelectedApprovalSelector = createSelector(
    EJourneySelector,
    (details) => details?.selectedApproval
);
export const SelectedApprovalDetailsSelector = createSelector(
    EJourneySelector,
    (details) => details?.selectedApprovalDetails
);
export const MultiSelectedApprovalsSelector = createSelector(
    EJourneySelector,
    (details) => details?.multiSelectedApprovals
);
export const SearchQuerySelector = createSelector(
    EJourneySelector,
    (details) => details?.searchQuery
);
export const IsAscSelector = createSelector(
    EJourneySelector,
    (details) => details?.isAsc
);
export const SelectedSubSystemSelector = createSelector(
    EJourneySelector,
    (details) => details?.selectedSubSystem
);
export const FromPositionSelector = createSelector(
    EJourneySelector,
    (details) => details?.fromPosition
);
export const SubSystemsSelector = createSelector(
    EJourneySelector,
    (details) => details?.subSystems
);
export const TotalCountForFilterSelector = createSelector(
    EJourneySelector,
    (details) => details?.totalCountForFilter
);
export const PendingApprovalsSelector = createSelector(
    EJourneySelector,
    (details) => details?.pendingApprovals
);
export const IsTabletViewSelector = createSelector(
    EJourneySelector,
    (details) => details?.isTabletView
  );


export const EJourneyReducer = EJourneySlice.reducer;

